<div class="header-container" [style]="isAirportPageColor()">
  <div class="header">
    <div class="header-side col-4 header-side-left">
      <button class="mobile-header-icon mobile-menu-button" (click)="toggleMobileMenu()">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <button class="mobile-header-icon mobile-search-button">
        <img src="assets/icons/search.svg" alt="Search">
      </button>

      <div class="desktop-header-left" *ngFor="let element of menuElements[0]">
        <div class="header-el">
          <span style="cursor: pointer" (click)="openUrl(element.url)">
            {{ languageService.translate(element.title) }}
          </span>
        </div>
      </div>
    </div>

    <div class="header-middle col-3">
      <span style="cursor: pointer" (click)="openUrl('/')">M+G</span>
    </div>

    <div class="header-side col-4 header-side-right" style="justify-content: flex-end;">
      <div class="header-el language-switcher" (click)="toggleLanguage()">
        {{ getLanguageLabel() }}
      </div>

      <div *ngFor="let element of menuElements[1]">
        <div *ngIf="element.label" class="header-el currency-switcher">
          <button class="currency-current" (click)="toggleCurrencyDropdown()">
            {{ currencyService.getSymbol() }}
          </button>

          <div class="currency-dropdown" *ngIf="isCurrencyDropdownOpen">
            <div
              class="currency-option"
              *ngFor="let currency of currencyService.currencies"
              [class.active]="currency.code === currencyService.currentCurrency()"
              (click)="selectCurrency(currency.code)">
              {{ currency.symbol }} {{ currency.label }}
            </div>
          </div>
        </div>

        <div *ngIf="element.icon" class="header-el" (click)="openModal()">
          <app-icon [icon]="element.icon" [invert]="isAirportPageInvert()" style="cursor: pointer"/>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mobile-menu-backdrop" [class.show]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

<div class="mobile-menu" [class.show]="isMobileMenuOpen">
  <div class="mobile-menu-head">
    <span>M+G</span>

    <button class="mobile-menu-close" (click)="closeMobileMenu()">
      ×
    </button>
  </div>

  <div class="mobile-menu-list">
    <div
      class="mobile-menu-item"
      *ngFor="let element of menuElements[0]"
      (click)="openUrl(element.url); closeMobileMenu()"
    >
      {{ languageService.translate(element.title) }}
    </div>

    <div class="mobile-menu-divider"></div>

    <div class="mobile-menu-setting-row" (click)="toggleLanguage()">
      <span>{{ languageService.translate(['Language', 'Язык']) }}</span>
      <strong>{{ getLanguageLabel() }}</strong>
    </div>

    <div class="mobile-menu-currency">
      <div class="mobile-menu-currency-title">
        {{ languageService.translate(['Currency', 'Валюта']) }}
      </div>

      <div class="mobile-menu-currency-list">
        <button
          class="mobile-menu-currency-option"
          *ngFor="let currency of currencyService.currencies"
          [class.active]="currency.code === currencyService.currentCurrency()"
          (click)="selectCurrency(currency.code)"
        >
          {{ currency.symbol }} {{ currency.code }}
        </button>
      </div>
    </div>
  </div>
</div>

<nav
  class="mobile-bottom-nav"
  [class.mobile-bottom-nav--light]="!isAirportPageInvert()"
>
  <button
    class="mobile-bottom-nav__item"
    type="button"
    (click)="toggleMobileMenu()"
  >
    <app-icon [icon]="Icons.menu" [invert]="!isAirportPageInvert()" />
  </button>

  <button class="mobile-bottom-nav__item" type="button" (click)="openUrl('/change-airport')">
    <app-icon [icon]="Icons.search" [invert]="!isAirportPageInvert()" />
  </button>

  <button class="mobile-bottom-nav__item" type="button" (click)="openUrl('/')">
    <app-icon [icon]="Icons.logo" [invert]="!isAirportPageInvert()" />
  </button>

  <button class="mobile-bottom-nav__item" type="button">
    <app-icon [icon]="Icons.heart" [invert]="!isAirportPageInvert()" />
  </button>

  <button class="mobile-bottom-nav__item mobile-bottom-nav__cart" type="button" (click)="openModal()">
    <app-icon [icon]="Icons.cartM" [invert]="!isAirportPageInvert()" />
  </button>
</nav>

<app-header-modal [isOpen]="isModalOpen" (close)="closeModal()"></app-header-modal>
